const SYSTEM_ADMINISTRATOR = 'SYSTEM_ADMINISTRATOR';
const BUYER_AFFILIATE = 'BUYER_AFFILIATE';
const AUTHORIZED_OFFICER = 'AUTHORIZED_OFFICER';
const CONTACT = 'CONTACT';

export const createPayload = (store, getResponse) => {
  let payload;
  const [user, authorizedOfficer, company] = store;
  if (getResponse?.data?.authorizedOfficerInfo != null) {
    payload = {
      systemAdministrator: {
        userId: getResponse?.data?.systemAdministrator?.userId,
        buyerOrganizationIdentifier: getResponse?.data?.systemAdministrator?.buyerOrganizationIdentifier,
        roleName: getResponse?.data?.systemAdministrator?.roleName,
        firstName: user.firstName,
        middleName: getResponse?.data?.systemAdministrator?.middleName,
        lastName: user.lastName,
        jobTitle: user.jobTitle,
        email: user.email,
        workPhone: user.businessPhone,
        extension: user.extension,
        cellPhone: user.cellPhone,
      },
      companyInformation: {
        correlationId: getResponse?.data?.companyInformationResponse?.correlationId,
        buyerOrganizationId: getResponse?.data?.companyInformationResponse?.buyerOrganizationId,
        phoneNumber: {
          number: company.corporatePhone,
          extension: company.extension,
          type: getResponse?.data?.companyInformationResponse?.buyerOrganizationId?.phoneNumber?.type,
        },
        buyerLegalName: company.entityName,
        buyerDbaName: company.dba,
        corporateEmailAddress: user.email,
        taxIdNumber: company.taxId,
        address: {
          streetAddressLine1: company.street1,
          streetAddressLine2: company.street2,
          city: company.city,
          postalCode: company.zip,
          state: company.state,
          country: company.country,
          addressType: getResponse?.data?.companyInformationResponse?.address?.addressType,
        },
        user: {
          role: getResponse?.data?.companyInformationResponse?.user?.role,
          firstName: getResponse?.data?.companyInformationResponse?.user?.firstName,
          lastName: getResponse?.data?.companyInformationResponse?.user?.lastName,
          email: getResponse?.data?.companyInformationResponse?.user?.email,
          phoneNumbers: getResponse?.data?.companyInformationResponse?.user?.phoneNumbers,
          roleId: getResponse?.data?.companyInformationResponse?.user?.roleId,
          userId: getResponse?.data?.companyInformationResponse?.user?.userId,
        },
      },
      formSubmitted: false,
    };
    if (user.authorizedOfficer === true) {
      payload.authorizedOfficer = {
        userId: getResponse?.data?.authorizedOfficerInfo?.userId,
        buyerOrganizationIdentifier: getResponse?.data?.systemAdministrator?.buyerOrganizationIdentifier,
        roleName: `${AUTHORIZED_OFFICER}`,
        firstName: user.firstName,
        middleName: getResponse?.data?.systemAdministrator?.middleName,
        lastName: user.lastName,
        jobTitle: user.jobTitle,
        email: user.email,
        workPhone: user.businessPhone,
        extension: user.extension,
        cellPhone: user.cellPhone,
      };
    } else {
      payload.authorizedOfficer = {
        userId: getResponse?.data?.authorizedOfficerInfo?.userId,
        buyerOrganizationIdentifier: getResponse?.data?.systemAdministrator?.buyerOrganizationIdentifier,
        roleName: `${AUTHORIZED_OFFICER}`,
        firstName: authorizedOfficer.firstName,
        middleName: null,
        lastName: authorizedOfficer.lastName,
        jobTitle: authorizedOfficer.jobTitle,
        email: authorizedOfficer.email,
        workPhone: authorizedOfficer.businessPhone,
        extension: authorizedOfficer.extension,
        cellPhone: authorizedOfficer.cellPhone,
      };
    }
  } else {
    payload = {
      systemAdministrator: {
        userId: getResponse?.data?.systemAdministrator?.userId,
        buyerOrganizationIdentifier: getResponse?.data?.systemAdministrator?.buyerOrganizationIdentifier,
        roleName: `${SYSTEM_ADMINISTRATOR}`,
        firstName: user.firstName,
        middleName: getResponse?.data?.systemAdministrator?.middleName,
        lastName: user.lastName,
        jobTitle: user.jobTitle,
        email: user.email,
        workPhone: user.businessPhone,
        extension: user.extension,
        cellPhone: user.cellPhone,
      },
      companyInformation: {
        correlationId: null,
        buyerOrganizationId: getResponse?.data?.companyInformationResponse?.buyerOrganizationId,
        phoneNumber: {
          number: company.corporatePhone,
          extension: company.extension,
          type: getResponse?.data?.companyInformationResponse?.buyerOrganizationId?.phoneNumber?.type,
        },
        buyerLegalName: company.entityName,
        corporateEmailAddress: user.email,
        buyerDbaName: company.dba,
        taxIdNumber: company.taxId,
        address: {
          streetAddressLine1: company.street1,
          streetAddressLine2: company.street2,
          city: company.city,
          postalCode: company.zip,
          state: company.state,
          country: company.country,
          addressType: getResponse?.data?.companyInformationResponse?.address?.addressType,
        },
        user: {
          role: `${BUYER_AFFILIATE}`,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          phoneNumbers: [{
            number: user.businessPhone? user.businessPhone : user.cellPhone,
            extension: user.extension,
            type: `${CONTACT}`,
          }],
        },
      },
      formSubmitted: false,
    };
    if (user.authorizedOfficer === true) {
      payload.authorizedOfficer = {
        userId: null,
        buyerOrganizationIdentifier: getResponse?.data?.systemAdministrator?.buyerOrganizationIdentifier,
        roleName: `${AUTHORIZED_OFFICER}`,
        firstName: user.firstName,
        middleName: getResponse?.data?.systemAdministrator?.middleName,
        lastName: user.lastName,
        jobTitle: user.jobTitle,
        email: user.email,
        workPhone: user.businessPhone,
        extension: user.extension,
        cellPhone: user.cellPhone,
      };
    } else {
      payload.authorizedOfficer = {
        userId: null,
        buyerOrganizationIdentifier: getResponse?.data?.systemAdministrator?.buyerOrganizationIdentifier,
        roleName: `${AUTHORIZED_OFFICER}`,
        firstName: authorizedOfficer.firstName,
        middleName: null,
        lastName: authorizedOfficer.lastName,
        jobTitle: authorizedOfficer.jobTitle,
        email: authorizedOfficer.email,
        workPhone: authorizedOfficer.businessPhone,
        extension: authorizedOfficer.extension,
        cellPhone: authorizedOfficer.cellPhone,
      };
    }
  }
  return payload;
};
export const userProfilePayload = (store, roleId, roleName) => {
  const [user] = store;

  const userPayload =
  {
    firstName: user?.firstName || '',
    middleName: user?.middleName || '',
    lastName: user?.lastName || '',
    businessTitle: user?.jobTitle || '',
    email: user?.email || '',
    phoneNumber: user?.businessPhone || '',
    phoneExtension: user?.extension || '',
    cellPhone: user?.cellPhone || '',
    status: 'ENABLED',
    selectedGroups: [],
    selectedRole: {'roleId': roleId, 'name': roleName,'timestamp':'AAAAAAAAtpg='}
  };
  console.log('userPayload', userPayload);
  return userPayload;
};

export const verifyPhoneNumberPayload = (userName, phoneNumber) => {

  const userPayload =
  {
    userName: userName || '',
    phoneNumber: phoneNumber || ''
  };
  return userPayload;
};
